// Web only has ExpensifyNeue-Regular so to achieve bold we need to add this fontWeight
export default '700';
